// Brightedge requires this to container to exist on web.
// They use the location of the container as the entrypoint to their link / keyword / SEO juicing.
export * from './bright-edge-container';
